import React from "react";
import { useState } from "react";
import { WalletController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { ApproveAccModal } from "../../pages";
import { object, string } from 'yup';

const ApproveAccModalContainer = ({ closeModal, requestData }) => {

    const [loading, setLoading] = useState(false);

    const validationSchema = () => {
		return object({
			status: string().required('Please select an Approval Decision'),
		});
	};

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            ...values
        }

        const { status, errorMessage } = await WalletController.approveAccountCreateRequest(payload)

        if (status === constant.Success) {
            setLoading(false);            
            MimaToastUtil.success({ message: status })      
            return closeModal();
        }

        setLoading(false);
        return MimaToastUtil.error({ message: errorMessage });
    }

    return (
        <ApproveAccModal
            onSubmit={onSubmit}            
            closeModal={closeModal}
            loading={loading} 
            validationSchema={validationSchema}
            requestData={requestData}     
        />
    )
}
export default ApproveAccModalContainer;